import { Navigate, Route, Routes } from 'react-router-dom';

import ParkingAdmin from 'src/features/parkingAdmin/components/ParkingAdmin';
import ParkingAdminLayout from 'src/features/parkingAdmin/components/ParkingAdminLayout';

const ParkingAdminRoutes = () => {
    return (
        <Routes>
            <Route path="" element={<ParkingAdminLayout />}>
                <Route path="" element={<ParkingAdmin />} />
                <Route path="*" element={<Navigate to=".." />} />
            </Route>
        </Routes>
    );
};

export default ParkingAdminRoutes;
